import { useMemo } from "react";

import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";
import type { SxProps } from "@mui/material/styles";

import { truncate } from "lodash";

import { convertHtmlToText } from "utils/common";

type StaffTaskDescriptionProps = {
  description: string;
  maxLength?: number;
  onClick?: () => void;
  sx?: SxProps;
};

export default function StaffTaskDescription({
  description,
  maxLength = 200,
  onClick,
  sx
}: StaffTaskDescriptionProps) {
  const { displayValue, plainText } = useMemo(() => {
    const plainText = convertHtmlToText(description);
    return {
      displayValue: !maxLength
        ? plainText
        : truncate(plainText, { length: maxLength, omission: "…" }),
      plainText
    };
  }, [description, maxLength]);

  return (
    <Tooltip title={plainText} disableInteractive>
      <Box sx={{ mt: 1, ...sx }}>
        <Typography
          variant="body2"
          sx={{
            cursor: onClick ? "pointer" : undefined,
            color: grey[600],
            "&:hover": {
              color: onClick ? grey[800] : undefined,
              textDecoration: "underline"
            }
          }}
          onClick={onClick}
        >
          {displayValue}
        </Typography>
      </Box>
    </Tooltip>
  );
}
